<template>
  <div>
    <McEditableTable
      v-show="isTableDataAvailable"
      ref="table"
      searchable
      :hasEmit:submitError="true"
      :apiClient="apiClient"
      :fields="fields"
      :apiErrorMappings="reasonApiErrorMappings"
      @available-change="handleDataAvailable"
      @submitError="handleSubmitError"
    />
    <div v-show="!isTableDataAvailable" class="empty-table-container">
      <McEmptyState
        :title="emptyStateProps.title"
        :desc="emptyStateProps.desc"
        @buttonPrimaryAction="handleAdd"
      />
    </div>
  </div>
</template>

<script>
import McEmptyState from '@/components/McEmptyState'
import McEditableTable from '@/components/McEditableTable'
import * as Reason from '@/services/rest-api/lib/delivery/reason'
import reasonApiErrorMappings from '../lib/constants/reason-api-error-mappings'

export default {
  components: {
    McEditableTable,
    McEmptyState,
  },
  data() {
    return {
      isTableDataAvailable: true,
      reasonApiErrorMappings,
    }
  },
  computed: {
    apiClient() {
      return {
        get: Reason.get("type eq 'TRANSFERRED'"),
        show: Reason.show,
        store: Reason.storeTransferType,
        update: Reason.updateTransferType,
        delete: Reason.deleteSingle,
      }
    },
    fields() {
      return [
        {
          name: 'reason',
          label: this.$t('setting.reasonTransfer.label'),
          placeholder: this.$t('setting.reasonTransfer.label'),
          key: 'reason',
          validation: 'required',
          editable: true,
          isSortable: true,
          help: true,
        },
      ]
    },
    emptyStateProps() {
      return {
        title: this.$t('setting.reasonTransfer.empty'),
        desc: this.$t('setting.reasonTransfer.add'),
      }
    },
  },
  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    handleAdd() {
      this.$refs.table.handleAdd()
    },
    handleSubmitError(data) {
      if (data.errors && data.status == 400) {
        if (data.errors.reason && data.errors.reason[0] == 'value is not unique') {
          this.$mcToast.error(this.$t('setting.reasonTransfer.error.valueNotUnique'))
          return
        }

        this.$mcToast.error(this.$t('global.inputFormatError'))
      }
    },
  },
}
</script>
